import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Flavors from './views/Flavors.vue'
import WhyVape from './views/WhyVape.vue'
import WhyCBD from './views/WhyCbd.vue'
import Contact from './views/Contact.vue'
import MobileMenu from './views/MobileMenu.vue'
import Products from './views/Products.vue'
import NewsFeed from './views/NewsFeed.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) return { selector: to.hash, offset: { x: 0, y: 50 }}
        else if (savedPosition) return savedPosition
        return { x: 0, y: 0 }
    },
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/about',
            name: 'about',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
        },
        {
            path: '/flavors',
            name: 'flavors',
            component: Flavors
        },
        {
            path: '/why-vape',
            name: 'whyvape',
            component: WhyVape
        },
        {
            path: '/why-cbd',
            name: 'whycbd',
            component: WhyCBD
        },
        {
            path: '/contact',
            name: 'contact',
            component: Contact
        },
        {
            path: '/mobile-menu',
            name: 'mobilemenu',
            component: MobileMenu
        },
        {
            path: '/products',
            name: 'products',
            component: Products
        },
        {
            path: '/newsfeed',
            name: 'newsfeed',
            component: NewsFeed
        }
    ]
})
